import { useCallback, useEffect, useState } from 'react';

import {
  PlayerFields,
  playerFields as fetchSelectedCountryState,
} from '@/api/common';
import { useCommonStore } from '@/store';

export const useCountryState = (selectedCountry: string) => {
  const [statesPending, setStatesPending] = useState(false);
  const [states, setStates] = useState<PlayerFields | null>(null);

  const user = useCommonStore.use.user();

  const fetchStateData = useCallback(async () => {
    try {
      setStatesPending(true);
      const { data } = await fetchSelectedCountryState(selectedCountry);
      setStates(data || null);
    } catch (error) {
      console.log(error);
    } finally {
      setStatesPending(false);
    }
  }, [selectedCountry]);

  useEffect(() => {
    if (!user?.state) {
      fetchStateData();
    }
  }, [fetchStateData, user]);

  return { statesPending, states };
};
